// enrichBuildings.js

const enrichBuildings = (buildings, jobSubscriptions) => {
  // Create a map of job subscriptions by JobSubscriptionId for quick lookup

   // Create a map of subscriptions by their IDs for quick lookup
   const jobSubscriptionsMap = jobSubscriptions?.reduce((map, sub) => {
    map[sub.JobSubscriptionId] = sub;
    return map;
}, {});


  // Iterate over the buildings array to enrich each building with its job subscriptions
  return buildings?.map(building => ({
    ...building,
    JobSubscriptions: building.JobSubscriptions?.map(id => jobSubscriptionsMap[id])?.filter(sub => sub !== undefined)
  }));
};

export default enrichBuildings;